import { VOID_CAVE_DEPTHS_EXIT_RECTS } from "./voidCaveDepthsMapConfig";
import {
  DEEP_GALLERY_MAP_CONFIG,
  RUNE_HOLLOW_MAP_CONFIG,
  WEST_GROTTO_MAP_CONFIG,
  WEST_PASSAGE_MAP_CONFIG,
} from "./westPassageMapConfigs";

const TILE_SIZE = 32;

export const WEST_PASSAGE_SCENE_KEY = "WestPassageScene";
export const WEST_GROTTO_SCENE_KEY = "WestGrottoScene";
export const RUNE_HOLLOW_SCENE_KEY = "RuneHollowScene";
export const DEEP_GALLERY_SCENE_KEY = "DeepGalleryScene";

// Spawn just below a doorway's floor sensor, facing back at the door.
const spawnBelowDoor = (rect) =>
  Object.freeze({
    x: rect.x + rect.width / 2,
    y: rect.y + rect.height + TILE_SIZE / 2,
  });

export const WEST_PASSAGE_RETURN_SPAWNS = Object.freeze({
  fromWestDoor: spawnBelowDoor(WEST_PASSAGE_MAP_CONFIG.exitRects.westDoor),
  fromNorthDoor: spawnBelowDoor(WEST_PASSAGE_MAP_CONFIG.exitRects.northDoor),
  fromEastDoor: spawnBelowDoor(WEST_PASSAGE_MAP_CONFIG.exitRects.eastDoor),
});

// Where leaving the west passage hub through its entrance drops you: right
// below the Deep Hollows' west doorway.
export const DEEP_HOLLOWS_WEST_DOOR_RETURN_SPAWN = spawnBelowDoor(
  VOID_CAVE_DEPTHS_EXIT_RECTS.westExit,
);

const HUB_EXIT_ROUTES = Object.freeze({
  westDoor: Object.freeze({
    sceneKey: WEST_GROTTO_SCENE_KEY,
    spawn: WEST_GROTTO_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
  northDoor: Object.freeze({
    sceneKey: RUNE_HOLLOW_SCENE_KEY,
    spawn: RUNE_HOLLOW_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
  eastDoor: Object.freeze({
    sceneKey: DEEP_GALLERY_SCENE_KEY,
    spawn: DEEP_GALLERY_MAP_CONFIG.entrySpawn,
    doorLabel: "Enter Passage",
  }),
});

const DEEP_GALLERY_EXIT_ROUTES = Object.freeze({
  northExit: Object.freeze({
    sceneKey: null,
    spawn: null,
    doorLabel: "North Passage",
    sealedMessage: "The passage groans behind the door... it is sealed for now.",
  }),
});

export const WEST_PASSAGE_SCENE_ROUTING = Object.freeze({
  [WEST_PASSAGE_SCENE_KEY]: Object.freeze({
    mapConfig: WEST_PASSAGE_MAP_CONFIG,
    storyMapId: "westPassage",
    storySpawnId: "west-passage-entry",
    entranceRoute: Object.freeze({
      sceneKey: "VoidCaveDepthsScene",
      spawn: DEEP_HOLLOWS_WEST_DOOR_RETURN_SPAWN,
      doorLabel: "Return To The Deep Hollows",
    }),
    entranceLabel: "Deep Hollows",
    exitRoutes: HUB_EXIT_ROUTES,
  }),
  [WEST_GROTTO_SCENE_KEY]: Object.freeze({
    mapConfig: WEST_GROTTO_MAP_CONFIG,
    storyMapId: "westGrotto",
    storySpawnId: "west-grotto-entry",
    entranceRoute: Object.freeze({
      sceneKey: WEST_PASSAGE_SCENE_KEY,
      spawn: WEST_PASSAGE_RETURN_SPAWNS.fromWestDoor,
      doorLabel: "Return To West Passage",
    }),
    entranceLabel: "West Passage",
    exitRoutes: Object.freeze({}),
  }),
  [RUNE_HOLLOW_SCENE_KEY]: Object.freeze({
    mapConfig: RUNE_HOLLOW_MAP_CONFIG,
    storyMapId: "runeHollow",
    storySpawnId: "rune-hollow-entry",
    entranceRoute: Object.freeze({
      sceneKey: WEST_PASSAGE_SCENE_KEY,
      spawn: WEST_PASSAGE_RETURN_SPAWNS.fromNorthDoor,
      doorLabel: "Return To West Passage",
    }),
    entranceLabel: "West Passage",
    exitRoutes: Object.freeze({}),
  }),
  [DEEP_GALLERY_SCENE_KEY]: Object.freeze({
    mapConfig: DEEP_GALLERY_MAP_CONFIG,
    storyMapId: "deepGallery",
    storySpawnId: "deep-gallery-entry",
    entranceRoute: Object.freeze({
      sceneKey: WEST_PASSAGE_SCENE_KEY,
      spawn: WEST_PASSAGE_RETURN_SPAWNS.fromEastDoor,
      doorLabel: "Return To West Passage",
    }),
    entranceLabel: "West Passage",
    exitRoutes: DEEP_GALLERY_EXIT_ROUTES,
  }),
});
